var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.75C2.25 5.92157 2.92157 5.25 3.75 5.25C4.57843 5.25 5.25 5.92157 5.25 6.75C5.25 7.57843 4.57843 8.25 3.75 8.25C2.92157 8.25 2.25 7.57843 2.25 6.75ZM6.75 6.75C6.75 6.33579 7.08579 6 7.5 6H21C21.4142 6 21.75 6.33579 21.75 6.75C21.75 7.16421 21.4142 7.5 21 7.5H7.5C7.08579 7.5 6.75 7.16421 6.75 6.75ZM2.25 12C2.25 11.1716 2.92157 10.5 3.75 10.5C4.57843 10.5 5.25 11.1716 5.25 12C5.25 12.8284 4.57843 13.5 3.75 13.5C2.92157 13.5 2.25 12.8284 2.25 12ZM6.75 12C6.75 11.5858 7.08579 11.25 7.5 11.25H21C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H7.5C7.08579 12.75 6.75 12.4142 6.75 12ZM2.25 17.25C2.25 16.4216 2.92157 15.75 3.75 15.75C4.57843 15.75 5.25 16.4216 5.25 17.25C5.25 18.0784 4.57843 18.75 3.75 18.75C2.92157 18.75 2.25 18.0784 2.25 17.25ZM6.75 17.25C6.75 16.8358 7.08579 16.5 7.5 16.5H21C21.4142 16.5 21.75 16.8358 21.75 17.25C21.75 17.6642 21.4142 18 21 18H7.5C7.08579 18 6.75 17.6642 6.75 17.25Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.50d301554b448b23ee6323ed2e4e9198.svg";
export { ForwardRef as ReactComponent };